<template>
  <div>

    <v-navigation-drawer
      class="white"
      v-model="drawer"
      app
    >

      <v-list-item-content>
        <v-list-item-title class="title text-center pa-1">
         Application
        </v-list-item-title>
        <v-list-item-subtitle class="text-center pa-1">
          subtext
        </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav dense flat>

        <v-list-item :to="{name: 'public-home'}" link class="nav-draw-link">
          <v-list-item-icon>
            <v-icon>play_arrow</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'app-home'}" link class="nav-draw-link">
          <v-list-item-icon>
            <v-icon>play_arrow</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>App</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'logout'}" link class="nav-draw-link">
          <v-list-item-icon>
            <v-icon>play_arrow</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

    </v-navigation-drawer>

    <v-app-bar
      app
      color="black"
      dark
      flat
    >
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img src="./images/logo-white.png" style="height: 40px; width: auto; margin: 8px"></img>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn small text>
          <router-link class="navbar-link" :to="{name: 'public-home'}">Home</router-link>
          <!-- <a class="navbar-link" href="/#/">Home</a> -->
        </v-btn>
      </v-toolbar-items>

       <v-toolbar-items class="hidden-sm-and-down">
        <v-btn small text>
          <router-link class="navbar-link" :to="{name: 'app-home'}">App</router-link>
        </v-btn>
      </v-toolbar-items>

       <v-toolbar-items class="hidden-sm-and-down">
        <v-btn small text>
          <router-link class="navbar-link" :to="{name: 'logout'}">Logout</router-link>
        </v-btn>
      </v-toolbar-items>

    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
  })
}
</script>

<style scoped>
.navbar-link {
  color: #CCC !important;
  text-decoration: none;
}
.nav-draw-link {
  color: #444 !important;
}
</style>
